import React from 'react';
import { 
  FaFileDownload, 
  FaBook, 
  FaUsers, 
  FaSchool,
  FaHandHoldingHeart, 
  FaPaintBrush, 
  FaHandshake, 
  FaLeaf,
  FaLaptopCode, 
  FaBalanceScale, 
  FaChartLine, 
  FaSearchDollar,
  FaDollarSign,
  FaGraduationCap,
  FaMedal,
  FaChartPie,
  FaRocket,
  FaSeedling,
  FaUniversity,        // Better for NIL programs
  FaClipboardCheck,    // Better for compliance/reporting
  FaBuilding,          // Better for corporate
  FaPeopleArrows,      // Better for donor-advised funds
  FaRecycle,           // Better for subscription-based
  FaUserFriends,       // Better for crowdfunding
  FaVideo,             // Add this import
  FaFilm,              // Add this import
  FaFileAlt           // Add this import
} from 'react-icons/fa';
import { MdSecurity } from 'react-icons/md';
import { BiNetworkChart } from 'react-icons/bi';
import { GiReceiveMoney, GiPayMoney } from 'react-icons/gi'; // Additional money-related icons

// Icon mapping for different resource types
const resourceIcons = {
  // Updated icons
  nilFoundation: FaUniversity,          // Academic/institutional feel for NIL
  nilFiscalSponsorship: FaClipboardCheck, // Compliance aspect of NIL
  grantPolicyReporting: FaBalanceScale,   // Justice/balance for policy
  corporatePhilanthropy: FaBuilding,      // Corporate/business
  donorAdvisedFunds: FaPeopleArrows,      // Shows relationship/transfer
  subscriptionBasedGiving: FaRecycle,      // Recurring/cyclical nature
  crowdfundingFiscalSponsorship: FaUserFriends, // Community/group funding

  // Existing mappings
  sportsPrograms: FaMedal,
  causePortfolio: BiNetworkChart,
  dynamicImpact: FaRocket,
  communityBasedPrograms: FaUsers,
  afterSchoolEducation: FaSchool,
  disasterReliefPrograms: FaHandHoldingHeart,
  artsCreativeIndustries: FaPaintBrush,
  strategicPartnerships: FaHandshake,
  environmentalInitiatives: FaLeaf,
  technologySolutions: FaLaptopCode,
  operationalCompliance: MdSecurity,
  grantFindingApplication: FaSearchDollar,
  fundraisingStrategies: FaDollarSign,
  scholarshipGrant: FaGraduationCap,
  default: FaFileDownload
};

const Resources = ({ resources }) => {
  return (
    <div className="resources-grid">
      {resources.map((resource) => (
        <div key={resource.id} className="resource-card">
          <div className="resource-icon">
            {resource.icon || <FaFileAlt />}
          </div>
          <h3>{resource.title}</h3>
          <p>{resource.description}</p>
          <button 
            className="download-button"
            onClick={resource.onClick}
          >
            Download Resource
          </button>
        </div>
      ))}
    </div>
  );
};

export default Resources; 